export default "__VITE_ASSET__D6_ial2P__"